<template>
  <div
    class="rounded-2xl flex flex-col gap-3 relative"
    :class="{
      'bg-block-2': type == 'block',
      'bg-block': type == 'secondary',
      'bg-blue-gradient': type == 'gradient',
      'bg-block-4 border border-block-2': type == 'info',
      'p-5': !chart,
    }"
  >
    <slot />
  </div>
</template>

<script>
export default {
  name: "Block",
  props: {
    type: {
      type: String,
      default: "block",
    },
    chart: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
